import React, {Fragment} from "react";
import Translate from "../../../components/Translate";

export default function FooterPassword({
                                           lengthOk,
                                           lettersDigitsOk,
                                           specialCharsOk,
                                           noForbinnedCharsOK,
                                       }) {

    const classOk = "fas fa-check ns-color ns-color--verde";
    const classKo = "fas fa-xmark ns-color ns-color--rosso";

    return (
        <Fragment>
            <Translate>La password deve essere composta da:</Translate>
            <ul className="fa-ul">
                <li>
                    <span className="fa-li"><i className={lengthOk ? classOk : classKo}/></span>
                    <Translate>Lunghezza minima di 8 caratteri</Translate>
                </li>
                <li>
                    <span className="fa-li"><i className={lettersDigitsOk ? classOk : classKo}/></span>
                    <Translate>Contenere almeno una lettera maiuscola, una minuscola e una cifra numerica</Translate>
                </li>
                <li>
                    <span className="fa-li"><i className={specialCharsOk ? classOk : classKo}/></span>
                    <Translate>Deve contenere almeno uno dei seguenti caratteri speciali ! # $ % & ' ( ) * + , - . : ; &lt; = &gt; @</Translate>
                </li>
                <li>
                    <span className="fa-li"><i className={noForbinnedCharsOK ? classOk : classKo}/></span>
                    <Translate>Non puo' contenere spazi, lettere accentate o altri caratteri diacritici ( àéç§ ecc...)</Translate>
                </li>
            </ul>
        </Fragment>
    );

}